import React, { useEffect} from "react";
import { useForm} from "react-hook-form";
import { useLocation  } from "react-router-dom";
import Header from "../components/Header";
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";
import {alert, confirm} from "../components/MegConfirmAlert";

export default function InquiryBulkWrite(props){
    const {register, handleSubmit, formState, reset, setValue }= useForm();
    const{errors} = formState;
    const { t } = useTranslation();

    const [request] = useAxios();
    const onSubmit = async data=> {
        
        if(data.nttSn){
            data.bbsSn = 2            
            const response = await request.post("/app/mypage/procInqryNttModifyAPI", data);
    
            if(response.data.resultCode === 200){
                await alert(response.data.resultMessage);
                window.location.reload();            
            }else{
                alert(response.data.resultMessage);
            }
        }else{
            data.bbsSn = 2
            data.aditfield5 = 'INQ003'
            const response = await request.post("/app/mypage/procInqryNttRegistAPI", data);
    
            if(response.data.resultCode === 200){
                await alert(response.data.resultMessage);
                window.location.reload();            
            }else{
                alert(response.data.resultMessage);
            }
        }
        
        
       
    }

    useEffect(() => {
        if(props.dataInfo.nttSn){
            setValue("nttSn",props.dataInfo.nttSn)
            setValue("nttSj",props.dataInfo.nttSj)
            setValue("nttCn",props.dataInfo.nttCn)
        }
      }, []);

    return (
        <div className={props.modal?'modalPage':'justPage'}>
            <Header type="black" pageTitle={t(`Message.bulk_order_inqry_regist_title`)} />

            <div className="formWr">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ul className="contUl">
                        <li>
                            <p className="tit">{t(`Message.inqry_info_page_sj`)}</p>
                            <input type="text" placeholder={t(`Message.inqry_info_page_hint_sj`)} {...register("nttSj", { required:t(`Message.inqry_info_page_required_sj`)})}/>
                            {errors.nttSj && <p role="alert" className="alertRed">{errors.nttSj.message}</p>}
                        </li>
                        <li>
                            <p className="tit">{t(`Message.inqry_info_page_cn`)}</p>
                            <textarea placeholder={t(`Message.inqry_info_page_hint_cn`)}  {...register("nttCn", { required:t(`Message.inqry_info_page_required_cn`)})} />
                            {errors.nttCn && <p role="alert" className="alertRed">{errors.nttCn.message}</p>}
                        </li>
                    </ul>

                    <button type="submit" className="floatBtn">{t(`Message.saveBtn`)}</button>  
                </form>
            </div>
        </div>
    );  
};